import { Suspense, lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const DictionaryAnalysisPage = lazy(
  () => import('@/pages/dictionary-analysis/ui/index'),
)

export const Route = createFileRoute('/_protected/dictionary/analysis')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense fallback={<Loader />}>
      <DictionaryAnalysisPage />
    </Suspense>
  )
}
